<template>
  <div class="media-wrap">
    <div class="header-title">渠道管理</div>
    <div class="flex">
      <div class="filter">
        <el-input
          v-model="search"
          style="width: 200px"
          placeholder="请输入渠道名"
        ></el-input>
        <el-select
          clearable
          v-model="isAbroad"
          style="width: 200px; margin-left: 16px"
          placeholder="所属地区"
        >
          <el-option label="国内" :value="0"></el-option>
          <el-option label="海外" :value="1"></el-option>
        </el-select>
        <el-button style="margin-left: 16px" @click="resetFilter">
          重置
        </el-button>
        <el-button type="primary" @click="searchData">查询</el-button>
      </div>
      <el-button type="primary" @click="handleAdd">添加</el-button>
    </div>
    <el-table
      :data="list"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
      ref="table"
    >
      <el-table-column label="排序" prop="firstFlag" width="150">
        <template slot-scope="scope">
          <el-input-number
            @change="changeFirstFlag($event, scope.row)"
            style="width: 100px"
            class="input-number"
            placeholder="请输入排序"
            v-model="scope.row.firstFlag"
            :controls="false"
            step-strictly
            :min="1"
            :max="999999"
          ></el-input-number>
        </template>
      </el-table-column>
      <!-- <el-table-column label="ID" prop="id" width="200"></el-table-column> -->
      <el-table-column label="渠道名" prop="mediaSource"></el-table-column>
      <el-table-column label="中文渠道名" prop="mediaSourceName">
        <template slot-scope="scope">
          {{ scope.row.mediaSourceName || "--" }}
        </template>
      </el-table-column>
      <el-table-column label="所属地区" prop="isAbroad">
        <template slot-scope="scope">
          {{
            scope.row.isAbroad === 0
              ? "国内"
              : scope.row.isAbroad === 1
              ? "海外"
              : "不限"
          }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.row)"
            >编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <self-pagination
      class="footer-page"
      :total="pageData.total"
      :pageSize="pageData.size"
      :currentPage="pageData.page"
      @getCurrentPage="changePage"
      @handleSizeChange="handleSizeChange"
    ></self-pagination>
    <el-dialog
      :title="modalType == 'add' ? '添加渠道' : '编辑渠道'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="600px"
    >
      <el-form :model="modalForm" ref="modalFormRef" label-width="100px">
        <el-form-item
          label="渠道名: "
          prop="mediaSource"
          :rules="[{ required: true, message: '渠道名不能为空' }]"
        >
          <el-input
            placeholder="请输入渠道名"
            v-model="modalForm.mediaSource"
          ></el-input>
        </el-form-item>
        <el-form-item label="中文渠道名: " prop="mediaSourceName">
          <el-input
            placeholder="请输入中文渠道名"
            v-model="modalForm.mediaSourceName"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="所属地区: "
          prop="isAbroad"
          :rules="[{ required: true, message: '所属地区不能为空' }]"
        >
          <el-radio-group v-model="modalForm.isAbroad">
            <el-radio :label="2">不限</el-radio>
            <el-radio :label="0">国内</el-radio>
            <el-radio :label="1">海外</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序: " prop="firstFlag">
          <el-input-number
            class="input-number"
            placeholder="请输入排序"
            v-model="modalForm.firstFlag"
            :controls="false"
            step-strictly
            :min="1"
            :max="999999"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirm" v-loading="btnLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  addMediaSource,
  getMediaSourcePageList,
  updateMediaSource,
} from "@/api/general.js";
export default {
  data() {
    return {
      search: "",
      isAbroad: "",
      list: [],
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      modalForm: {
        mediaSource: "",
        mediaSourceName: "",
        isAbroad: 0,
        firstFlag: 1,
        id: "",
      },
      modalType: "add",
      dialogVisible: false,
      btnLoading: false,
    };
  },

  computed: {},

  watch: {},

  mounted() {
    this.searchData();
  },

  methods: {
    resetFilter() {
      this.search = "";
      this.isAbroad = "";
      this.changePage(1);
    },
    searchData() {
      getMediaSourcePageList({
        pageNum: this.pageData.page,
        pageSize: this.pageData.size,
        search: this.search,
        isAbroad: this.isAbroad,
      }).then((res) => {
        if (res.code == "0000") {
          this.list = res.data.list;
          this.pageData.total = res.data.total;
        }
      });
    },
    changeFirstFlag(data, row) {
      updateMediaSource({
        ...row,
      });
    },
    handleAdd() {
      this.modalForm = {
        mediaSource: "",
        mediaSourceName: "",
        isAbroad: 2,
        firstFlag: 1,
      };
      this.modalType = "add";
      this.dialogVisible = true;
    },
    handleEdit(data) {
      this.modalForm = {
        mediaSource: data.mediaSource,
        mediaSourceName: data.mediaSourceName,
        isAbroad: data.isAbroad,
        firstFlag: data.firstFlag,
        id: data.id,
      };
      this.modalType = "edit";
      this.dialogVisible = true;
    },
    handleConfirm() {
      this.$refs.modalFormRef.validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          if (this.modalType == "add") {
            addMediaSource({
              ...this.modalForm,
            }).then((res) => {
              this.btnLoading = false;
              if (res.code == "0000") {
                this.$message.success("添加成功");
                this.changePage(1);
                this.dialogVisible = false;
              }
            });
          } else {
            updateMediaSource({
              ...this.modalForm,
            }).then((res) => {
              this.btnLoading = false;
              if (res.code == "0000") {
                this.$message.success("编辑成功");
                this.changePage(1);
                this.dialogVisible = false;
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    changePage(page) {
      this.pageData.page = page;
      this.searchData();
    },
    handleSizeChange(size) {
      this.pageData.size = size;
      this.pageData.page = 1;
      this.searchData();
    },
  },
};
</script>

<style lang="less" scoped>
.media-wrap {
  margin: 16px;
  height: calc(100vh - 110px);
  padding: 16px 24px 16px 24px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .header-title {
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
    font-size: 15px;
    flex: 1;
    margin-bottom: 16px;
  }
  .filter {
    flex: 1;
    margin-bottom: 16px;
  }
  /deep/ .is-required .el-form-item__label::before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
  }
  .input-number {
    width: 440px;
    /deep/ .el-input__inner {
      text-align: left;
    }
  }
}
</style>
